import { render, staticRenderFns } from "./ClientesList.vue?vue&type=template&id=1d21afbc&scoped=true&"
import script from "./ClientesList.vue?vue&type=script&lang=js&"
export * from "./ClientesList.vue?vue&type=script&lang=js&"
import style0 from "./ClientesList.vue?vue&type=style&index=0&id=1d21afbc&prod&lang=scss&scoped=true&"
import style1 from "./ClientesList.vue?vue&type=style&index=1&id=1d21afbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d21afbc",
  null
  
)

export default component.exports